/* Keep Dawn's native menu, keyboard and focus behaviour; add the cart-style backdrop. */
(() => {
  'use strict';
  if (typeof document === 'undefined') return;
  function init() {
    if (document.querySelector('[data-sora-native-menu-backdrop]')) return;
    const roots = 'header-menu > details, header-drawer > details';
    const backdrop = document.createElement('button');
    backdrop.type = 'button';
    backdrop.className = 'sora-menu-backdrop';
    backdrop.tabIndex = -1;
    backdrop.hidden = true;
    backdrop.setAttribute('aria-label', 'Close navigation menu');
    backdrop.setAttribute('data-sora-native-menu-backdrop', '');
    document.body.append(backdrop);
    const menus = () => [...document.querySelectorAll(roots)];
    const visible = (details) => details.open && details.parentElement.getClientRects().length > 0;
    function sync() {
      const open = menus().filter(visible);
      backdrop.hidden = open.length === 0;
      document.body.classList.toggle('sora-navigation-open', open.length > 0);
      document.querySelectorAll('.section-header').forEach((header) => {
        header.classList.toggle('sora-navigation-layer', open.some((details) => header.contains(details)));
      });
    }
    function close(details, event, restoreFocus = false) {
      const host = details.parentElement;
      const summary = details.querySelector('summary');
      if (host.tagName === 'HEADER-DRAWER' && typeof host.closeMenuDrawer === 'function') {
        host.closeMenuDrawer(event, summary);
      } else if (typeof host.close === 'function') {
        host.close();
      } else {
        details.open = false;
      }
      summary?.setAttribute('aria-expanded', 'false');
      if (restoreFocus) summary?.focus();
    }
    function closeAll(event, restoreFocus) {
      const open = menus().filter((details) => details.open);
      const focusTarget = open.filter(visible).pop();
      open.forEach((details) => close(details, event, restoreFocus && details === focusTarget));
      sync();
    }
    backdrop.addEventListener('click', (event) => closeAll(event, true));
    document.addEventListener('toggle', (event) => {
      if (!event.target.matches?.(roots)) return;
      if (event.target.open && event.target.parentElement.tagName === 'HEADER-MENU') {
        menus().filter((details) => details !== event.target && details.open).forEach((details) => close(details, event));
      }
      sync();
    }, true);
    document.addEventListener('keydown', (event) => {
      // Mobile submenu Escape remains controlled by Dawn's own keyup handler.
      if (event.key === 'Escape' && menus().some((details) => visible(details) && details.parentElement.tagName === 'HEADER-MENU')) {
        event.preventDefault();
        closeAll(event, true);
      }
    });
    window.addEventListener('resize', sync);
    document.addEventListener('shopify:section:load', sync);
    document.addEventListener('shopify:section:unload', () => queueMicrotask(sync));
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
